var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconMarker = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 21,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.014 20.153c3.171 0 6.433-2.287 6.433-6.153 0-2.16-1.117-3.656-3.495-4.802-1.085-.528-2.287-.935-3.32-1.405C4.546 6.885 3.96 5.828 3.96 4.45c0-1.727 1.117-2.842 2.79-2.842 1.911 0 3.643 1.574 5.258 4.801l.588-.09-.498-5.74h-.498l-1.144.992c-.969-.56-1.97-.966-3.436-.966-2.965 0-5.994 2.112-5.994 5.598 0 2.14 1.086 3.75 3.145 4.775.911.439 1.997.819 2.939 1.204 2.759 1.141 3.437 1.992 3.437 3.75 0 1.85-1.234 3.223-3.352 3.223s-4.2-1.347-6.052-5.568l-.615.059.35 6.507h.53l1.143-1.025a9.91 9.91 0 0 0 4.464 1.025Z",
  fill: "#B18D3B"
})));

export default SvgIconMarker;